module.exports = __webpack_public_path__ + "img/IL.d3a98b53.png";